export default "__VITE_ASSET__t53E2xkc__"